import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import Media from 'sb-media'
import cx from 'classnames'
import { injectIntl } from 'sb-react-intl'

import Modal from 'components/modal/Modal/Modal'
import Animation from 'components/ui/Animation/Animation'

import messages from './messages'
import s from './HowQueueWorksModal.scss'

import mobileImage from './images/mobile.gif'
import exceptMobileImage from './images/except-mobile.gif'
import mobileVideo from './images/mobile.mp4'
import exceptMobileVideo from './images/except-mobile.mp4'


class HowQueueWorksModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.shape({
      onClose: PropTypes.func,
      monthName: PropTypes.string,
    }),
  }

  static defaultProps = {
    name: constants.modals.HowQueueWorks,
  }

  handleCloseModal = () => {
    const { data: { onClose } } = this.props

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  render() {
    const { data: { monthName, ...rest }, intl, name } = this.props

    const hasMonthName = Boolean(monthName)
    const modalTitle = hasMonthName
      ? intl.formatMessage(messages.chooseTitle, { month: monthName.toUpperCase() })
      : intl.formatMessage(messages.queueTitle)

    const modalClassName = cx({
      [s.dark]: !hasMonthName,
    })

    return (
      <Modal
        className={modalClassName}
        name={name}
        title={modalTitle}
        data={rest}
        onClose={this.handleCloseModal}
      >
        <Media mobile>
          {
            (isMobile) => (
              <Animation
                src={isMobile ? mobileVideo : exceptMobileVideo}
                fallbackSrc={isMobile ? mobileImage : exceptMobileImage}
              />
            )
          }
        </Media>
      </Modal>
    )
  }
}


export default injectIntl(HowQueueWorksModal)
